export default "__VITE_ASSET__3919cd0d__"